'use client';

import React from 'react';
import Tippy from '@tippyjs/react';


export default function SafeTooltip({ children, content, placement, disabled = false }) {
	return (
		<Tippy
			placement={placement}
			content={content}
			delay={[450, 0]}
			animation="shift-away-subtle"
			inertia
			disabled={!content || disabled}
		>
			{children}
		</Tippy>
	);
}
